export enum TrackLabelCodes {
	AudioNetwork = 27831,
	AudioMachine = 29653,
}

export const getLabelCode = (publisherName: string): number => {
	return publisherName === 'Audio Network Rights Limited'
		? TrackLabelCodes.AudioNetwork
		: TrackLabelCodes.AudioMachine
}
